import script from "./ProcessoSecao.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessoSecao.vue?vue&type=script&setup=true&lang=js"

import "./ProcessoSecao.vue?vue&type=style&index=0&id=762ac56e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762ac56e"]])

export default __exports__